// extracted by mini-css-extract-plugin
module.exports = {"notificationList":"Notifications_notificationList__xmEMn"};